setTimeout(function(){ 
	if (window.location.href.indexOf("privacy") > -1) {
      	$('#yoHolder').css('z-index','0');
		$('#refcandy-poprocks div').css('z-index','0');     
	}
}, 5000);


(function($) {
  $(document).ready(function(){
	populateForms();
  })
})(jQuery);


function populateForms() {
  if (window.location.href.indexOf("privacy") > -1) {
    displayInfo();
    displayDelete();
  }
}

function displayInfo(){
	$.ajax({
		type: 'GET',
		url: 'https://idyllwind.com/pages/ccpa-info',
		success: function(data){
			var html = $(data).find('.ccpa-info');
			$('.ccpa_pop_content').append(html);
		},
		dataType: "html"
	});
}

function displayDelete(){
	$.ajax({
		type: 'GET',
		url: 'https://idyllwind.com/pages/ccpa-delete',
		success: function(data){
			var html = $(data).find('.ccpa-delete');
			$('.ccpa_pop_content').append(html);
		},
		dataType: "html"
	});
}

function showCCPA(request){
    $('.not-' + request).hide();
    $('.ccpa-' + request).show();
    displayForm();
}

function displayForm(){	
  setTimeout(function(){ 
    $('.ccpa_pop').css('display', 'flex').fadeIn('fast');
}, 500);
}

function closeCCPA(){
	$('.ccpa_pop').stop(true,true).fadeOut(500, function(){
        $('.ccpa_pop_content').find('.ccpa-info').hide();
		$('.ccpa_pop_content').find('.ccpa-delete').hide();
        //populateForms();
	});
}



/*function showCCPA(request){
	$.ajax({
		type: 'GET',
		url: 'https://idyllwind.com/pages/ccpa-' + request,
		success: function(data){
			var html = $(data).find('.ccpa-' + request);
			$('.ccpa_pop_content').append(html);
		},
		dataType: "html"
	}); 
  displayForm();
}

function displayForm(){	
  setTimeout(function(){ 
    $('.ccpa_pop').css('display', 'flex').fadeIn('fast');
}, 1000);
}

function closeCCPA(){
	$('.ccpa_pop').stop(true,true).fadeOut(500, function(){
        $('.ccpa_pop_content').find('.ccpa-info').remove();
		$('.ccpa_pop_content').find('.ccpa-delete').remove();
	});
}*/


